import React from "react";
import { Helmet } from "react-helmet";

// This component is used to dynamically update the page title, meta description, and canonical URL for each page using react helmet
const SEO = ({ title, description, canonicalUrl, prerenderStatusCode, blogPost, image }) => {
  const fullTitle = `${title}`;
  // Use provided image, or blogPost image, or fallback to default
  const socialImage = image || blogPost?.image || "https://d3a0rs3velfrz.cloudfront.net/logos/mainLogo.svg";

  // Environment detection for blocking search engine crawling on development subdomain
  const isDevelopment =
    process.env.REACT_APP_ENV === "development" || (typeof window !== "undefined" && window.location.hostname === "development.almadelic.com");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {isDevelopment && <meta name="robots" content="noindex, nofollow" />}
      {description && <meta name="description" content={description} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {prerenderStatusCode && <meta name="prerender-status-code" content={prerenderStatusCode}></meta>}

      {/* Open Graph Tags for social sharing */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={socialImage} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:type" content={blogPost ? "article" : "website"} />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={socialImage} />
    </Helmet>
  );
};

export default SEO;

// Enhanced from original to include proper social share images and Open Graph/Twitter meta tags
